<template>
	<transition name="fade">
		<div class="preloader">
			<div class="preloader-wrapper">
				<div class="dot" style="--i: 0"></div>
				<div class="dot" style="--i: 1"></div>
				<div class="dot" style="--i: 2"></div>
				<div class="dot" style="--i: 3"></div>
				<div class="dot" style="--i: 4"></div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "PreloaderComponent"
}
</script>

<style scoped lang="scss">

$d: 2em;
$t: 1.5s;

.preloader {
	height: 100%;
	width: 100%;

	&-wrapper {
		--n: 5;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	.dot {
		background: #404E6E;

		&, &:after {
			background: #404E6E;
			display: inline-block;
			width: $d;
			height: $d;
			border-radius: 50%;
			animation: a $t calc(((var(--i) + var(--o, 0)) / var(--n) - 1) * #{$t}) infinite
		}

		&:after {
			--o: 1;
			background: #404E6E;
			content: ''
		}
	}

	@keyframes a {
		0%, 50% {
			transform: scale(0)
		}
	}
}

.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
}

</style>